<template>
  <div class="strategy_wrap">
    <navbar_ :Lucency="false" :isBlack="true" :activeIndex="''" />

    <div class="strategy_container">
      <div class="strategy_list">
        <div
          class="strategy_item"
          v-for="(item, index) in strategyList"
          :key="index"
          @click="strategyClick(item)"
        >
          <div class="title">{{ item.name }}</div>

          <div class="yield_box">
            <div class="sy_box">
              <div class="box">
                <div class="txt">近7日收益率</div>

                <div class="sy" :class="{ sy_: item.yieldRate < 0 }">
                  {{ item.yieldRate >= 0 ? "+" : ""
                  }}{{ COMMON.formatToFixed(item.yieldRate) }}%
                </div>
              </div>

              <div class="box">
                <div class="txt">胜率</div>

                <div class="sy" :class="{ sy_: item.winRate < 0 }">
                  {{ COMMON.formatToFixed(item.winRate) }}%
                </div>
              </div>
            </div>

            <div class="curve_box">
              <div ref="chart" class="chart_container"></div>
            </div>
          </div>

          <div class="operation_box">
            <div class="numDay">运行天数：{{ item.operationDays }}天</div>

            <div class="numPeople">
              <img src="@/assets/ai_stock/strategy/people.png" />：{{
                item.subscriberCount
              }}
            </div>
          </div>

          <div class="btn">点击查看策略详情</div>
        </div>
      </div>
    </div>

    <footer_ />
  </div>
</template>

<script>
import navbar_ from "@/components/navbar/index.vue"; // 顶部导航
import footer_ from "@/components/footer/index.vue"; // 底部

import { markRaw } from "vue";
import * as echarts from "echarts";

export default {
  components: {
    navbar_,
    footer_,
  },
  data() {
    return {
      strategyList: [],

      charts: [],
      handleResize: null,
    };
  },
  created() {},
  mounted() {
    this.getStrategyList(); // 获取 AI 策略列表
  },
  beforeUnmount() {
    // 组件销毁时，销毁所有 ECharts 实例
    this.charts.forEach((chart) => {
      if (chart) {
        chart.dispose();
      }
    });

    this.removeResizeListener(); // 移除resize监听
  },
  methods: {
    // 获取 AI 策略列表
    getStrategyList() {
      this.API.CLOUDGet("quant/api/ai-strategy/list", {}).then((res) => {
        // console.log(res);
        let datas = res.data.data;
        // console.log(datas);

        this.strategyList = datas;

        this.initCharts();
        this.addResizeListener(); // 添加resize监听
      });
    },

    initCharts() {
      // 使用 $refs 获取所有图表容器
      this.$nextTick(() => {
        this.$refs.chart.forEach((chartDom, index) => {
          const chart = markRaw(echarts.init(chartDom));
          this.charts.push(chart); // 存储实例
          this.setChartOptions(chart, this.strategyList[index].yields);
        });
      });
    },
    setChartOptions(chart, data) {
      let that = this;

      let datas = data.map((item) => item.day);
      let profits = data.map((item) => item.yield);

      let maxValue = Math.max(...profits);
      let minValue = Math.min(...profits);

      // 计算零值在Y轴上的相对位置
      let zeroPosition = 0.5; // 默认中间位置
      let lineGradientStops = [];
      let areaGradientStops = [];

      if (minValue >= 0) {
        // 所有数据都 >= 0，整体使用红色
        zeroPosition = 1; // 零线在底部
        lineGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.8)" },
          { offset: 1, color: "rgba(255, 0, 0, 0.8)" },
        ];
        areaGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.3)" },
          { offset: 1, color: "rgba(255, 0, 0, 0.1)" },
        ];
      } else if (maxValue <= 0) {
        // 所有数据都 <= 0，整体使用绿色
        zeroPosition = 0; // 零线在顶部
        lineGradientStops = [
          { offset: 0, color: "rgba(38, 163, 116, 0.8)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.8)" },
        ];
        areaGradientStops = [
          { offset: 0, color: "rgba(38, 163, 116, 0.1)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.3)" },
        ];
      } else {
        // 数据跨越零值，需要计算零值位置
        zeroPosition = 1 - (0 - minValue) / (maxValue - minValue);
        lineGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.8)" },
          { offset: zeroPosition - 0.001, color: "rgba(255, 0, 0, 0.8)" },
          { offset: zeroPosition, color: "rgba(127, 127, 127, 0.5)" },
          { offset: zeroPosition + 0.001, color: "rgba(38, 163, 116, 0.8)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.8)" },
        ];
        areaGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.3)" },
          { offset: zeroPosition - 0.005, color: "rgba(255, 0, 0, 0.1)" },
          { offset: zeroPosition, color: "rgba(127, 127, 127, 0)" },
          { offset: zeroPosition + 0.005, color: "rgba(38, 163, 116, 0.1)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.3)" },
        ];
      }

      let option = {
        grid: {
          top: "0", // 上边距
          right: "3px", // 右边距
          bottom: "0", // 下边距（关键调整项）
          left: "3px", // 左边距
          containLabel: true, // 确保坐标轴标签在 grid 内
        },
        xAxis: {
          type: "category",
          data: datas,
          show: false,
          boundaryGap: false,
        },
        yAxis: {
          show: false,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
        },
        series: [
          {
            name: "收益率",
            type: "line",
            data: profits,
            showSymbol: false,
            smooth: true,
            itemStyle: {
              color: (params) => {
                return params.data >= 0 ? "#ff0000" : "#26a374";
              },
            },
            lineStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                lineGradientStops
              ),
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                areaGradientStops
              ),
            },
          },
        ],
      };

      chart.setOption(option);
    },

    // 添加resize监听
    addResizeListener() {
      this.handleResize = () => {
        this.charts.forEach((chart) => {
          try {
            chart && chart.resize();
          } catch (e) {
            console.error("图表重绘失败:", e);
          }
        });
      };
      window.addEventListener("resize", this.handleResize);
    },
    // 移除resize监听
    removeResizeListener() {
      if (this.handleResize) {
        window.removeEventListener("resize", this.handleResize);
      }
    },

    // 策略 click
    strategyClick(item) {
      console.log(item);

      this.COMMON.routerSkip("strategy", {
        code: item.code,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.strategy_wrap {
  padding-top: 60px;

  .strategy_container {
    min-height: calc(100vh - 116px);
    padding: 28px 100px;
    background: #050a1a;

    .strategy_list {
      display: flex;
      flex-wrap: wrap;

      .strategy_item {
        width: calc((100% - 48px) / 3);
        // height: 300px;
        border: 2px solid #28324b;
        box-sizing: border-box;
        margin-right: 24px;
        margin-bottom: 24px;
        color: #fff;
        padding: 20px 24px;
        transition: transform 0.3s ease;
        cursor: pointer;

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:hover {
          transform: scale(1.05);
        }

        .title {
          font-weight: bold;
          font-size: 16px;
        }

        .yield_box {
          display: flex;
          justify-content: space-between;
          margin-top: 16px;

          .sy_box {
            width: 100px;

            .box {
              margin-top: 16px;

              &:first-child {
                margin-top: 0;
              }

              .txt {
                font-size: 12px;
              }

              .sy {
                color: #ff0000;
                font-weight: bold;
                font-size: 18px;
                margin-top: 10px;

                &.sy_ {
                  color: #26a374;
                }
              }
            }
          }

          .curve_box {
            width: calc(100% - 124px);

            .chart_container {
              width: 100%;
              height: 116px;
            }
          }
        }

        .operation_box {
          font-size: 12px;
          margin-top: 12px;
          display: flex;
          justify-content: space-between;

          .numPeople {
            display: flex;

            img {
              width: 16px;
              height: 16px;
            }
          }
        }

        .btn {
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          margin-top: 14px;
          background: #28324b;
          border-radius: 30px;
          text-align: center;
        }
      }
    }
  }
}
</style>